import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import '../../styles/home/FAQ.css';

const FAQ = () => {
  const [openTab, setOpenTab] = useState(null);

  const toggleTab = (index) => {
    setOpenTab(openTab === index ? null : index);
  };

  const faqData = [
    { 
      question: "I've never been on a boat. What should I expect?",
      answer: "Expect amazing views, good music, and ocean vibes! Our crew is used to working with first-time guests — we'll walk you through everything, from safety instructions to the best spots to chill and take photos."
    },
    { 
      question: "Will I get seasick?",
      answer: "Most of our routes are calm, especially in Biscayne Bay. If you’re prone to motion sickness, we suggest taking precautions ahead of time, like eating a light meal before boarding and staying hydrated to help ensure a smooth and enjoyable experience."
    },
    { 
      question: "Can I bring kids or babies on board?",
      answer: "Yes! All of our boats are family-friendly. Let us know in advance so we can prepare child-size life jackets."
    },
    { 
      question: "Can we bring food and drinks on board?",
      answer: "Absolutely. You're welcome to bring your own, or ask us about our catering and beverage packages for a stress-free day."
    },
    { 
      question: "Do you provide cups or plates?",
      answer: "We recommend bringing your own cups, utensils, napkins, and any other essentials you may need. That said, we do keep a few extras on board just in case you run out — we've got you covered!"
    },
    { 
      question: "How early should we arrive before departure?",
      answer: "Please arrive at least 15–20 minutes early so we can load up and start on time. Miami traffic is no joke!"
    }
  ];
  
  return (
    <section className="faq-section">
      <div className="section-intro">
        <h2>Frequently Asked Questions</h2>
      </div>
      <div className="faq-container">
        <div className="faq-column">
          {faqData.filter((_, index) => index % 2 === 0).map((faq, index) => {
            const tabIndex = index * 2;
            const isOpen = openTab === tabIndex;
            return (
              <div key={index} className={`faq-item${isOpen ? ' open' : ''}`}>
                <div className="faq-question" onClick={() => toggleTab(tabIndex)}>
                  <FontAwesomeIcon icon={isOpen ? faChevronUp : faQuestionCircle} />
                  <h3>{faq.question}</h3>
                </div>
                {isOpen && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="faq-column">
          {faqData.filter((_, index) => index % 2 !== 0).map((faq, index) => {
            const tabIndex = index * 2 + 1;
            const isOpen = openTab === tabIndex;
            return (
              <div key={index} className={`faq-item${isOpen ? ' open' : ''}`}>
                <div className="faq-question" onClick={() => toggleTab(tabIndex)}>
                  <FontAwesomeIcon icon={isOpen ? faChevronUp : faQuestionCircle} />
                  <h3>{faq.question}</h3>
                </div>
                {isOpen && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    
      <div className="faq-view-more">
        <Link to="/faqs-page" className="button">View More</Link>
      </div>
    </section>
  );
};

export default FAQ;